import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
// import NProgress from "@/utils/progress";
import routes from "./routes";
import { useTitle } from '@vueuse/core'
import { getToken } from '@/utils/auth'
import { pageDefaultTitle } from '@/settings';
import { autoLogin } from '@/utils/autoLogin'

// console.log(createWebHistory(import.meta.env.VITE_BASE_URL))
// console.log(createWebHashHistory(import.meta.env.VITE_BASE_URL))

const router = createRouter({
  history: createWebHashHistory(import.meta.env.VITE_BASE_URL),
  routes
})

// 路由白名单
const whiteList = ['/login', '/home','/register','/resetPassword', '/404', '/403'];

router.beforeEach(async (to, from, next) => {
  // NProgress.start();
  useTitle(to.meta.title || pageDefaultTitle)
  if (getToken()) {
    if (to.path === '/login') {
      next({ path: '/' });
    } else {
      next();
    }
  } else if (whiteList.includes(to.path)) {
    // 未登录直接进入首页（或根路径重定向到首页）时，用默认账号自动登录
    if (to.path === '/home') {
      const ok = await autoLogin();
      if (ok) {
        // 重新触发守卫，此时已有 token，正常放行
        next({ ...to, replace: true });
        return;
      }
    }
    next();
  } else {
    // 未登录访问受保护页面，跳转登录页
    next('/login');
  }
});

router.afterEach(() => {
  // NProgress.done();
});

export default router
